// extracted by mini-css-extract-plugin
export default {"LeftMenu":"LeftMenu_LeftMenu__--GMz","sider":"LeftMenu_sider__VcmFy","collapseBtn":"LeftMenu_collapseBtn__rAC7x"};